import { useInvitesStore } from "@/shared/stores/invitesStore";
import styles from "./InviteModal.module.scss";
import { MailIcon } from "./assets/MailIcon";
import { UserIcon } from "./assets/UserIcon";

interface InviteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function InviteModal({ isOpen, onClose }: InviteModalProps) {
  const {
    invites,
    currentInviteIndex,
    loadingAction,
    acceptCurrentInvite,
    declineCurrentInvite,
  } = useInvitesStore();

  const currentInvite = invites[currentInviteIndex];
  const isLoading = loadingAction !== null;

  if (!isOpen || !currentInvite) {
    return null;
  }

  const totalInvites = invites.length;

  const formattedExpirationDate = new Date(
    currentInvite.expires_at,
  ).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <div className={styles.overlay} onClick={isLoading ? undefined : onClose}>
      <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.title}>
          Новое приглашение
          <br />
          {totalInvites > 1 && `(${currentInviteIndex + 1} из ${totalInvites})`}
        </h3>
        <p className={styles.message}>
          Вы приглашены в магазин «{currentInvite.supplier.name}»
        </p>

        <p className={styles.userDataMessage}>
          Чтобы Вас узнать, продавцу будут отображаться следующие данные:
        </p>
        <div className={styles.userDataSection}>
          <ul className={styles.userDataList}>
            <li>
              <UserIcon /> Имя
            </li>
            <li>
              <MailIcon /> E-mail
            </li>
          </ul>
        </div>
        <p className={styles.bottomMessage}>
          Приглашение действительно до {formattedExpirationDate}
        </p>

        <div className={styles.buttons}>
          <button
            onClick={acceptCurrentInvite}
            className={`${styles.button} ${styles.confirmButton}`}
            disabled={isLoading}
          >
            {loadingAction === "accept" ? (
              <div className={styles.spinner} />
            ) : (
              "Принять"
            )}
          </button>
          <button
            onClick={declineCurrentInvite}
            className={`${styles.button} ${styles.cancelButton}`}
            disabled={isLoading}
          >
            {loadingAction === "decline" ? (
              <div className={styles.spinner} />
            ) : (
              "Отклонить"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
